/** Map Memorial Photo Link product ids to API size enum. */
export function product_size_from_type(productTypeOrId) {
  const key = String(productTypeOrId || '').toLowerCase();
  if (key.includes('a6')) return 'A6';
  if (key.includes('a4')) return 'A4';
  if (key.includes('square') || key.includes('certificate')) return 'certificate';
  if (key.includes('card')) return 'card';
  if (key.includes('plaque')) return 'plaque_preview';
  return 'A5';
}
